export default __webpack_public_path__ + "static/media/banner-edit.b901517f.svg";